import { Toilet } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { auth, signOut } from '@/lib/firebase';

const LogoutButton = ({ className = '' }: { className?: string }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
      toast.success('Logged out successfully');
    } catch {
      toast.error('Error logging out');
    }
  };

  return (
    <Button variant="outline" onClick={handleLogout} className={className}>
      <Toilet className="h-4 w-4 mr-2" />
      Flush
    </Button>
  );
};

export default LogoutButton;
